import type { ElementOptions } from "../types/index.js";
import { AttributesState } from "../attribute/attributes-state.js";

export class ElementState {
  public readonly name: string;

  constructor(
    name: string,
    private options: ElementOptions,
  ) {
    this.name = name.toLowerCase();
  }

  get attributes(): AttributesState {
    return new AttributesState(this.options.attributes);
  }

  parent(): ElementState | null {
    if (!this.options.ancestors) {
      return null;
    }

    const iterator = this.options.ancestors()[Symbol.iterator]();
    const first = iterator.next();

    if (first.done || !first.value) {
      return null;
    }

    return new ElementState(first.value.name, first.value);
  }

  ancestors(): Iterable<
    {
      name: string;
    } & ElementOptions
  > {
    return this.options.ancestors?.() || [];
  }
}
